import { ConfigProvider } from 'antd'
import locale from 'antd/lib/locale/ko_KR'

import Routers from 'routers/router'

import AppLayout from 'layout/AppLayout'
import TokenConfig from 'utils/tokenConfig'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import 'dayjs/locale/ko' // 한국어 로캘을 불러옵니다
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { useNavigate, useLocation } from 'react-router-dom'
import 'assets/scss/ui.scss' // 공통 scss
import { useDispatch } from 'react-redux'
import { authGetSession, authSignout } from 'api/user/user.api'
import { getUserAsync } from 'store/Slices/user'
import Spinner from 'components/AntD/Spin'
import ReactGA from 'react-ga4'

const gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID // 환경 변수에 저장된 GA4 추적 ID 가져오기
ReactGA.initialize(gaTrackingId) // GA4 초기화

dayjs.locale('ko') // antd datepicker 한글화
dayjs.extend(utc) // UTC 플러그인 적용하기
dayjs.extend(timezone) // 한국 타임존 적용
dayjs.extend(isBetween) // 현재 날짜가 중간에 위치하는지 확인하는 플러그인

dayjs.tz.setDefault('Asia/Seoul')

const App = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const [initialLoading, setInitialLoading] = useState(true)

    useEffect(() => {
        const restoreSession = async () => {
            try {
                const { session } = await authGetSession()

                if (session && session.access_token) {
                    const { email } = session.user
                    const data = await dispatch(getUserAsync(email))

                    // 로그인 페이지에 있을 때만 메인으로 이동
                    if (data?.type?.includes('fulfilled') && location.pathname === '/login') {
                        navigate('/main')
                    }
                } else {
                    navigate('/login')
                }
            } catch (error) {
                await dispatch(authSignout())
            } finally {
                // 무조건 로딩 완료 처리
                setInitialLoading(false)
            }
        }

        restoreSession()
    }, [dispatch, location.pathname, navigate])

    // 페이지 경로가 변경될 때마다 GA 페이지뷰 전송 (GA4)
    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search }) // 페이지 경로 + 쿼리 파라미터를 포함하여 페이지 뷰 전송
    }, [location.pathname]) // 페이지 경로 변경 시마다 호출

    // 초기 세션 확인 중이면 로딩 화면만 보여줌
    if (initialLoading) {
        return <Spinner />
    }

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: TokenConfig(),
                hashed: false,
            }}
        >
            <AppLayout>
                <Routers />
            </AppLayout>
        </ConfigProvider>
    )
}

export default App
